import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {Inject, Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {TranslocoService} from '@ngneat/transloco'
import {shouldNotIntercept} from './prevent.interceptor'

@Injectable()
export class I18nInterceptor implements HttpInterceptor {
  constructor(@Inject(TranslocoService) private localeService: TranslocoService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (shouldNotIntercept(req)) {
      return next.handle(req)
    }

    const reqWithLang = req.clone({setHeaders: {'x-bgo-language': this.localeService.getActiveLang()}})
    return next.handle(reqWithLang)
  }
}
